import React, { FC } from 'react';
import { formatSnapshotValue } from 'utils/formatters/orderPipelineAudit';
import { SnapshotChange } from 'api/admin/orders/getOrderPipelineAudit';
import { SNAPSHOT_FIELD_LABELS } from 'constants/order/orderPipelineAudit';
import styles from './OrderPipelineHistory.module.scss';

interface ChangeRowProps {
  change: SnapshotChange;
}

/**
 * One before/after row of a pipeline run's snapshot diff.
 *
 * Falls back to the raw field name when the backend reports a field this UI has no label for — the
 * change still has to be visible, since an unlabelled money field is exactly the kind of thing an
 * operator is here to find.
 */
export const ChangeRow: FC<ChangeRowProps> = ({ change }) => (
  <div className={styles.changeRow}>
    <span className={styles.changeField}>
      {SNAPSHOT_FIELD_LABELS[change.field] ?? change.field}
    </span>

    <span className={styles.changeFrom}>{formatSnapshotValue(change.field, change.from)}</span>
    <span aria-hidden>→</span>
    <span className={styles.changeTo}>{formatSnapshotValue(change.field, change.to)}</span>
  </div>
);
